/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract HeaderCache",
                name: "in_headerCache",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "headerHash",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "accountAddress",
                type: "address",
            },
        ],
        name: "AccountNotFound",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "blockHash",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "accountAddress",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "rlpAccountProof",
                type: "bytes",
            },
        ],
        name: "add",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "balance",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "storageRoot",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "codeHash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct AccountCache.Account",
                name: "account",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "blockHash",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "accountAddress",
                type: "address",
            },
        ],
        name: "exists",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "blockHash",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "accountAddress",
                type: "address",
            },
        ],
        name: "get",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "balance",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "storageRoot",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "codeHash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct AccountCache.Account",
                name: "account",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "headerCache",
        outputs: [
            {
                internalType: "contract HeaderCache",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "stateRoot",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "accountAddress",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "rlpAccountProof",
                type: "bytes",
            },
        ],
        name: "verifyAccount",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "balance",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "storageRoot",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "codeHash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct AccountCache.Account",
                name: "account",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class AccountCache__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(in_headerCache, overrides) {
        return super.getDeployTransaction(in_headerCache, overrides || {});
    }
    deploy(in_headerCache, overrides) {
        return super.deploy(in_headerCache, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
AccountCache__factory.bytecode = _bytecode;
AccountCache__factory.abi = _abi;
//# sourceMappingURL=AccountCache__factory.js.map